import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle, Star, Shield, Users, Calendar } from "lucide-react";
import { chateauxService, sumosService } from "@/config/contentConfig";

export const ServiceDetails = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
      {/* Châteaux Gonflables Details */}
      <Card className="p-8">
        <CardHeader>
          <CardTitle className="text-2xl font-display flex items-center">
            <span className="text-3xl mr-3">{chateauxService.icon}</span>
            {chateauxService.title}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div>
            <h4 className="font-semibold mb-3 flex items-center">
              <CheckCircle className="w-5 h-5 mr-2 text-primary" />
              Matériel inclus dans chaque location
            </h4>
            <ul className="space-y-2 ml-7">
              {chateauxService.included.map((item, index) => (
                <li key={index}>• {item}</li>
              ))}
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-3 flex items-center">
              <Star className="w-5 h-5 mr-2 text-accent" />
              Thèmes disponibles
            </h4>
            <div className="grid grid-cols-2 gap-2 ml-7">
              {chateauxService.themes.map((theme, index) => (
                <span key={index}>• {theme}</span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-3 flex items-center">
              <Shield className="w-5 h-5 mr-2 text-fun" />
              Sécurité et qualité
            </h4>
            <ul className="space-y-2 ml-7">
              {chateauxService.safety.map((item, index) => (
                <li key={index}>• {item}</li>
              ))}
            </ul>
          </div>
        </CardContent>
      </Card>

      {/* Sumos Details */}
      <Card className="p-8">
        <CardHeader>
          <CardTitle className="text-2xl font-display flex items-center">
            <span className="text-3xl mr-3">{sumosService.icon}</span>
            {sumosService.title}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div>
            <h4 className="font-semibold mb-3 flex items-center">
              <CheckCircle className="w-5 h-5 mr-2 text-primary" />
              Matériel inclus pour les sumos
            </h4>
            <ul className="space-y-2 ml-7">
              {sumosService.included.map((item, index) => (
                <li key={index}>• {item}</li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-3 flex items-center">
              <Users className="w-5 h-5 mr-2 text-secondary" />
              Conditions d'utilisation
            </h4>
            <ul className="space-y-2 ml-7">
              {sumosService.requirements.map((item, index) => (
                <li key={index}>• {item}</li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-3 flex items-center">
              <Calendar className="w-5 h-5 mr-2 text-fun" />
              Occasions parfaites
            </h4>
            <ul className="space-y-2 ml-7">
              {sumosService.occasions.map((item, index) => (
                <li key={index}>• {item}</li>
              ))}
            </ul>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};